// extracted by mini-css-extract-plugin
export default {"logoWrap":"HeaderNavbar_logoWrap__pcMxV","logo":"HeaderNavbar_logo__WiOtH","learnLogo":"HeaderNavbar_learnLogo__mIaQ4","scaLogo":"HeaderNavbar_scaLogo__YZxDL"};